import React, { useEffect } from 'react'
import styled from 'styled-components'
import { ExtensionInstance, NavbarItem, NavbarSubItem } from '../type'
import i18n from 'live/services/i18n'
import TableForm from 'live/components/forms/ui/TableForm'
import _ from 'lodash'
import { FormCheckbox } from 'live/components/forms/ui/form-checkbox'
import FormGroup from 'live/components/forms/ui/form-group'

type FormConfig = {
    defineNavbar: boolean
} & ExtensionInstance

interface NavbarConfigFormProps {
    type: string
    active: boolean
    config: FormConfig
    fullQualifier: string
    qualifier: string
    status: Record<string, unknown>
    setState: (state: { object: NavbarConfigFormProps } & { mustSave?: boolean }) => void
    stateObject: { object: NavbarConfigFormProps }
}

const initialState: NavbarItem[] = [
    {
        title: '',
        dashboardId: '',
        subItems: []
    }
]

export const NavbarConfigForm = (props: NavbarConfigFormProps): JSX.Element => {
    const { config, setState, stateObject } = props
    const [localState, setLocalState] = React.useState<NavbarItem[]>(config?.navbar || initialState)

    useEffect(() => {
        setLocalState(config?.navbar?.length > 0 ? config?.navbar : initialState)
    }, [config])

    const updateState = (data: NavbarItem[]): void => {
        setState({
            ...stateObject,
            object: {
                ...stateObject.object,
                config: {
                    ...config,
                    navbar: data
                }
            },
            mustSave: true
        })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, i: number): void => {
        const { name, value } = e.target

        const tmp: NavbarItem[] = _.clone(localState)
        tmp[i][name] = value

        setLocalState(tmp)
        updateState(tmp)
    }

    const handleChangeSubItems = (data: NavbarSubItem[], i: number): void => {
        const tmp: NavbarItem[] = _.clone(localState)

        tmp[i].subItems = data

        tmp.forEach(t => {
            if (t.subItems?.length) {
                t.dashboardId = ''
            }
        })

        setLocalState(tmp)
        updateState(tmp)
    }

    const addNavbarItem = (): void => {
        const tmp: NavbarItem[] = _.clone(localState)

        tmp.push({
            title: '',
            dashboardId: '',
            subItems: []
        })

        setLocalState(tmp)
        updateState(tmp)
    }

    const removeNavbarItem = (i: number): void => {
        const tmp: NavbarItem[] = localState.filter((_, index) => index !== i)

        setLocalState(tmp)
        updateState(tmp)
    }

    return (
        <Container>
            <FormCheckbox
                name="define-navbar"
                disabled={false}
                checked={config?.defineNavbar}
                onChange={e => {
                    setState({
                        ...stateObject,
                        object: {
                            ...stateObject.object,
                            config: {
                                ...config,
                                defineNavbar: e.target.checked
                            }
                        },
                        mustSave: true
                    })
                }}
                description={i18n('Define Navbar')}
            />

            {config?.defineNavbar && (
                <ContainerRow>
                    <div className="row-form">
                        <div className="row-inner">
                            <div className="row-inner__item">
                                <span>Title</span>
                                <span>Dashboard ID</span>
                            </div>
                        </div>
                    </div>
                    {localState.map((item, index) => {
                        return (
                            <div className="row-form" key={index}>
                                <div className="row-inner">
                                    <div className="row-inner__item">
                                        <FormGroup
                                            type="text"
                                            // label={i18n('Title')}
                                            name="title"
                                            value={item.title}
                                            onChange={e => handleChange(e, index)}
                                            // validationState={this.validationState('config.pageType')}
                                            hasFeedback
                                            // help={this.errorsFor('config.pageType')}
                                        />
                                        <FormGroup
                                            type="text"
                                            disabled={item.subItems.length > 0}
                                            // label={i18n('Dashboard ID')}
                                            name="dashboardId"
                                            value={item.dashboardId}
                                            onChange={e => handleChange(e, index)}
                                            // validationState={this.validationState('config.pageType')}
                                            hasFeedback
                                            // help={this.errorsFor('config.pageType')}
                                        />
                                    </div>
                                    <TableForm
                                        key={index + '__'}
                                        data={item.subItems}
                                        allowAddRow={true}
                                        allowRemoveRow={true}
                                        onChange={data => handleChangeSubItems(data as NavbarSubItem[], index)}
                                        fields={[
                                            { name: 'title', label: 'Title', type: 'text' },
                                            { name: 'item', label: 'Item', type: 'text' },
                                            { name: 'dashboardId', label: 'Dashboard ID', type: 'text' }
                                        ]}
                                    />
                                    <ActionArea class="area-delete" onClick={() => removeNavbarItem(index)}>
                                        <RowAction color={'red'} className="far fa-trash-alt" />
                                    </ActionArea>
                                </div>
                            </div>
                        )
                    })}
                    <button onClick={addNavbarItem}>+ ADD NAVBAR ITEM</button>
                </ContainerRow>
            )}
        </Container>
    )
}

const Container = styled.div`
    padding: 24px 0px;
    width: 100%;
    height: 100%;
`
const ActionArea = styled.div`
    width: 100%;
    /* border: 1px solid red; */
    background: rgb(240, 245, 251);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 2px;
`
const RowAction = styled.i`
    display: inline-block;
    padding: 3px;
    color: ${({ color }) => color || 'var(--gray-800)'};
    cursor: pointer;
`

const ContainerRow = styled.div`
    /* border: 1px solid #000; */
    width: 100%;

    .form-group {
        margin-bottom: 0;
        width: 100%;
        flex: 1;
    }
    button {
        width: 100%;
        height: 25px;
    }
    .row-form {
        width: 100%;
        /* border: 1px solid blue; */
        &:first-child {
            span {
                flex: 1;
            }
        }
        &:not(:first-child) {
            padding-bottom: 24px;
        }

        display: flex;
        align-items: flex-end;

        .row-inner {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .row-inner__item {
                width: 100%;
                display: flex;
            }
        }
    }
`
